import React, {Component} from 'react'
import PropTypes from 'prop-types'

class ProductType extends Component {
    _onClickType = (value) => {
        const {onChangeProductType} = this.props

        if (typeof onChangeProductType === 'function') {
            onChangeProductType(value)
        }
    }

    render() {
        const {types} = this.props

        return (
            <td className="Products">
                {
                    types !== undefined && types.map((type, index) => {
                        return type !== null &&
                            <span key={index} className="mr-2" onClick={() => this._onClickType([type])}>{type}</span>
                    })
                }
            </td>
        )
    }
}

ProductType.propTypes = {
    types: PropTypes.array,
    onChangeProductType: PropTypes.func
}

export default ProductType